import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CarouselModule } from 'ngx-owl-carousel-o';


import { AppRoutingModule } from './app-routing.module';
import { SportsComponent } from './sports/sports.component';
import { AppComponent } from './app.component';

// ── Layout & Shared Components ───────────────────────────────────────────────
import { LayoutComponent }          from './layout/layout.component';
import { HeaderComponent }          from './components/header/header.component';
import { DesktopHeaderComponent }   from './components/desktop-header/desktop-header.component';
import { HeaderNavComponent }       from './components/header-nav/header-nav.component';
import { SideBarComponent }         from './components/side-bar/side-bar.component';
import { RightNavComponent }        from './components/right-nav/right-nav.component';
import { FooterDesktopComponent }   from './components/footer-desktop/footer-desktop.component';
import { BottomNavComponent }       from './components/bottom-nav/bottom-nav.component';
import { LoaderComponent }          from './loader/loader.component';
import { BetLoaderComponent }       from './bet-loader/bet-loader.component';
import { TooltipComponent }         from './tooltip/tooltip.component';

// ── Pages ─────────────────────────────────────────────────────────────────────
import { DashboardComponent }        from './pages/dashboard/dashboard.component';
import { LoginUnityComponent }       from './login-unity/login-unity.component';
import { OldCasinoComponent }        from './old-casino/old-casino.component';
import { CasinoslotComponent }       from './casinoslot/casinoslot.component';
import { VirtualsportsComponent }    from './virtualsports/virtualsports.component';
import { LotteryComponent }          from './lottery/lottery.component';
import { LotteryDetailsComponent }   from './lottery-details/lottery-details.component';
import { HorseRacingComponent }      from './horse-racing/horse-racing.component';
import { CricketComponent }          from './cricket/cricket.component';
import { SoccerComponent }           from './soccer/soccer.component';
import { TennisComponent }           from './tennis/tennis.component';
import { BallbyballComponent }       from './ballbyball/ballbyball.component';
import { BetslipComponent }          from './betslip/betslip.component';
import { SideNavBetsComponent }      from './side-nav-bets/side-nav-bets.component';
import { MarketTabsComponent }       from './market-tabs/market-tabs.component';
import { SettingsModuleComponent }   from './settings-module/settings-module.component';
import { VideoSimpleComponent }      from './video-simple/video-simple.component';
import { VideoBallbyBallComponent }  from './video-ballby-ball/video-ballby-ball.component';
import { TipsAndPreviewsComponent }  from './tips-and-previews/tips-and-previews.component';
import { TipsAndPreviewsDetailsComponent } from './tips-and-previews-details/tips-and-previews-details.component';
import { InplayComponent } from './inplay/inplay.component';
import { MarketsComponent } from './markets/markets.component';
import { MarketDetailsComponent } from './market-details/market-details.component';
import { MultimarketComponent } from './multimarket/multimarket.component';
import { LivecasinoComponent } from './livecasino/livecasino.component';
import { BetHistoryComponent } from './pages/bet-history.component';
import { ProfitLossComponent } from './pages/profit-loss.component';
import { AccountStatementComponent } from './pages/account-statement.component';
import { ActivityLogComponent } from './pages/activity-log.component';
import { PasswordHistoryComponent } from './pages/password-history.component';
import { RollingCommissionComponent } from './pages/rolling-commission.component';
import { AdminComponent } from './admin/admin.component';

@NgModule({
  declarations: [
    SportsComponent,
    AppComponent, LayoutComponent,
    HeaderComponent, DesktopHeaderComponent, HeaderNavComponent,
    SideBarComponent, RightNavComponent, FooterDesktopComponent, BottomNavComponent,
    LoaderComponent, BetLoaderComponent, TooltipComponent,
    DashboardComponent, LoginUnityComponent, OldCasinoComponent,
    CasinoslotComponent, VirtualsportsComponent, LotteryComponent, LotteryDetailsComponent,
    HorseRacingComponent, CricketComponent, SoccerComponent, TennisComponent,
    BallbyballComponent, BetslipComponent, SideNavBetsComponent,
    MarketTabsComponent, SettingsModuleComponent,
    VideoSimpleComponent, VideoBallbyBallComponent,
    TipsAndPreviewsComponent, TipsAndPreviewsDetailsComponent, InplayComponent, MarketsComponent, MarketDetailsComponent, MultimarketComponent, LivecasinoComponent, BetHistoryComponent, ProfitLossComponent, AccountStatementComponent, ActivityLogComponent, PasswordHistoryComponent, RollingCommissionComponent,
    AdminComponent,
  ],
  imports: [
    BrowserModule, BrowserAnimationsModule,
    HttpClientModule, FormsModule, ReactiveFormsModule,
    AppRoutingModule,
    CarouselModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}
